import { Head } from 'vite-react-ssg';
import { Search, MapPin } from 'lucide-react';
import { Container, Eyebrow } from '../components/ui-bits';
import { ListingCard } from '../components/ListingCard';
import { CATEGORIES, FEATURED } from '../directory/data';

/** /discover — the directory index: search, activities, featured listings. */
export default function DiscoverIndex() {
  return (
    <main>
      <Head>
        <title>Discover gyms, classes, courts &amp; coaches near you | TechSoFit</title>
        <meta
          name="description"
          content="Browse fitness places and people near you: gyms, swimming, racket sports, classes, personal trainers and more. Find somewhere to be active on TechSoFit."
        />
      </Head>

      <section className="py-16 md:py-20">
        <Container>
          <Eyebrow>Discover</Eyebrow>
          <h1 className="mt-3 font-display text-display-md text-ink">Find somewhere to be active.</h1>
          <p className="mt-4 max-w-2xl text-lg text-ink-soft">
            Browse gyms, courts, pools, studios, classes and coaches near you.
          </p>

          <div className="mt-6 flex max-w-xl items-center gap-2 rounded-pill bg-card px-4 py-3 text-sm text-muted shadow-card">
            <Search className="size-4 shrink-0" />
            <span className="flex-1">Search by activity or area (coming soon)</span>
            <MapPin className="size-4 shrink-0" />
          </div>

          <h2 className="mt-12 font-display text-xl font-semibold text-ink">Browse by activity</h2>
          <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {CATEGORIES.map((c) => (
              <a
                key={c.key}
                href={`/discover/${c.key}`}
                className="flex items-start gap-3 rounded-card bg-card p-4 shadow-card transition-transform hover:-translate-y-0.5"
              >
                <span className="inline-flex size-10 shrink-0 items-center justify-center rounded-full bg-accent-soft text-ink">
                  {c.icon({ className: 'size-5' })}
                </span>
                <span>
                  <span className="block font-medium text-ink">{c.label}</span>
                  <span className="block text-sm text-muted">{c.blurb}</span>
                </span>
              </a>
            ))}
          </div>

          <h2 className="mt-12 font-display text-xl font-semibold text-ink">Featured near you</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {FEATURED.map((l) => (
              <ListingCard key={l.slug} listing={l} />
            ))}
          </div>
        </Container>
      </section>
    </main>
  );
}
